import { PropsWithChildren } from 'react';
import styles from './Grid.module.scss';
import { TObject } from '@types';
import { Item } from './GridItem';
import { useMediaQuery } from '@hooks';

type TProps = {
	container?: boolean;
	item?: boolean;
	columns?: number;
	mobileColumns?: number;
	tabletColumns?: number;
	laptopColumns?: number;
	desktopColumns?: number;
	minWidth?: string;
	maxWidth?: string;
	gap?: string;
	columnGap?: string;
	rowGap?: string;
	rowHeight?: string;
	columnTemplate?: string;
	rowTemplate?: string;
	alignItems?: string;
	inline?: boolean;
}

const GridContainer = (props:PropsWithChildren<TProps>) => {
	const {
		columns = 2,
		mobileColumns,
		tabletColumns,
		laptopColumns,
		desktopColumns,
		minWidth = '200px',
		maxWidth = '1fr',
		gap,
		columnGap = '16px',
		rowGap = '16px',
		rowHeight,
		columnTemplate,
		rowTemplate,
		alignItems,
		children,
		inline
	} = props;
	const {
		isDesktop,
		isLaptop,
		isTablet,
		isMobile
	} = useMediaQuery();

	const setContainerStyles = () => {
		let cols = columns;
		if (isDesktop && desktopColumns) cols = desktopColumns;
		if (isLaptop && laptopColumns) cols = laptopColumns;
		if (isTablet && tabletColumns) cols = tabletColumns;
		if (isMobile && mobileColumns) cols = mobileColumns;
		const styles:TObject = {};
		const totalGapWidth = (cols - 1) * parseInt(gap ?? columnGap);
		const repeat = `repeat(auto-fill, minmax( max(${minWidth}, calc((100% - ${totalGapWidth}px) / ${cols})), ${maxWidth}))`;
		const colTemplate = columnTemplate?.replace(/{repeat}/g, repeat);
		styles.gridTemplateColumns = colTemplate ?? repeat;
		const rowTemp = rowTemplate?.replace(/{repeat}/g, repeat);
		styles.gridTemplateRows = rowTemp ?? '';
		if (gap) {
			styles.gap = gap;
		} else {
			styles.rowGap = rowGap;
			styles.columnGap = columnGap;
		}
		if (rowHeight) {
			styles.gridAutoRows = rowHeight;
		}
		if (alignItems) {
			styles.alignItems = alignItems;
		}
		if (inline) {
			styles.display = 'inline-grid'
		}
		return styles;
	}

	return (
		<div data-testid={'@Ofload-Grid'} className={styles.container} style={setContainerStyles()}>
			{children}
		</div>
	);
}

GridContainer.Item = Item;

export const Grid = GridContainer;
